export const getCellId = (rowId: string, columnId: string) => {
  return `${rowId}_${columnId}`
}
